import { ICustomersInitialContext } from "./CustomersProviderTypes"

export const CUSTOMERS_INITIAL_CONTEXT: ICustomersInitialContext = {
  customers: {
    data: [],
    itemCount: 0,
    skip: 0,
    take: 10
  },
  customersDataLoading: false,
  query: {
    search: "",
    sortBy: "id",
    pageIndex: 1,
    pageSize: 10,
  },
  currentCustomerId: "",
  reservations: {
    data: [],
    itemCount: 0,
    skip: 0,
    take: 10
  },
  currentCustomer: null,
  handleCustomersPaginationClick: () => {},
  handleSearchChange: () => {},
  handleSearchClick: () => {},
  handleBlockUnblockClick: () => {},
  handleDeleteClick:  () => {},
  setState: () => {},
  searchValue: "",
  vehicles: [],
  handleAutosClick: () => {},
  handleReservationsClick: () => {},
  handleTransactionsClick: () => {}
}

export const CUSTOMERS_INITIAL_STATE = {
  customers: {
    data: [],
    itemCount: 0,
    skip: 0,
    take: 10
  },
  reservations: {
    data: [],
    itemCount: 0,
    skip: 0,
    take: 10
  },
  currentCustomer: null,
  currentCustomerId: "",
  searchValue: ""  
}